/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Build_Empty_TitleInputs */

const en_us2_plan_build_empty_title = /** @type {(inputs: Plan_Build_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build it your way`)
};

const pt_br2_plan_build_empty_title = /** @type {(inputs: Plan_Build_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monte do seu jeito`)
};

const es_419_plan_build_empty_title = /** @type {(inputs: Plan_Build_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ármalo a tu manera`)
};

const pt_pt2_plan_build_empty_title = /** @type {(inputs: Plan_Build_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monta-o à tua maneira`)
};

const fr_fr2_plan_build_empty_title = /** @type {(inputs: Plan_Build_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Construis-le à ta façon`)
};

const de_de2_plan_build_empty_title = /** @type {(inputs: Plan_Build_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bau ihn nach deinen Wünschen`)
};

const it_it2_plan_build_empty_title = /** @type {(inputs: Plan_Build_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creala a modo tuo`)
};

/**
* | output |
* | --- |
* | "Build it your way" |
*
* @param {Plan_Build_Empty_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_build_empty_title = /** @type {((inputs?: Plan_Build_Empty_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Build_Empty_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_build_empty_title(inputs)
	if (locale === "es-419") return es_419_plan_build_empty_title(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_build_empty_title(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_build_empty_title(inputs)
	if (locale === "de-DE") return de_de2_plan_build_empty_title(inputs)
	if (locale === "it-IT") return it_it2_plan_build_empty_title(inputs)
	return en_us2_plan_build_empty_title(inputs)
});
export { plan_build_empty_title as "plan-build.empty_title" }